import * as deliveryAddressAction from "./deliveryAddressActions";
export default function deliveryAddressReducer(state, action) {
  switch (action.type) {
    case deliveryAddressAction.deliveryAddressActions.ADD_UPDATE_ADDRESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
